import BasketIconBadgeSFC from "./BasketIconBadge.vue";

export const BasketIconBadge = BasketIconBadgeSFC;
